// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fed0f6cd","644":"630d3ccd","667":"447c5110"}[chunkId] + ".chunk.js";
};